export enum EmployeeSorting {
    PublicIdAscending = 'PublicIdAscending',
    PublicIdDescending = 'PublicIdDescending',
    NameAscending = 'NameAscending',
    NameDescending = 'NameDescending',
    CreationDateAscending = 'CreationDateAscending',
    CreationDateDescending = 'CreationDateDescending'
}